import DynamicForm from '@components/shared-ui-components/DynamicForm'
import { Paper } from '@mui/material'

function TargetSelectionPage() {
  return (
    <Paper
      elevation={3} // Add shadow effect
      sx={{
        padding: '20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <h4>Please fill up the Target Selection form</h4>
      <DynamicForm page={'targetSelection'} />
    </Paper>
  )
}

export default TargetSelectionPage